import styles from './Loader.module.scss';
import PropTypes from 'prop-types';

export default function Loader(props) {
	const { loading, label } = props;

	return (
		<>
			<div className={`${styles.loader} ${loading && styles.loader__active}`}>
				<div className={styles.loader__spinner} /> {label && <span className={styles.loader__label}>{label}</span>}
			</div>
		</>
	);
}
Loader.Prototype = {
	loading: PropTypes.bool,
	label: PropTypes.string
};

Loader.defaultProps = {
	loading: false,
	label: ''
};
